/* @flow */
import { RECEIVE_FOUNDRY_RESPONSE } from '../actions/foundry_response';
import {get} from 'lodash';
import type { Action } from '../actions/types';

const INITIAL_STATE = {};

export default (state: SeriesState = INITIAL_STATE, action: Action): SeriesState => {
  switch (action.type) {
    case RECEIVE_FOUNDRY_RESPONSE:
      const series = get(action, 'data.content.series', {});
      return series.id === state.id ? state : series;
    default:
      return state;
  }
};

type SeriesState = {
  id?: number
};
